import { jsx as _jsx } from "react/jsx-runtime";
import { css, styled } from 'styled-components';
import { BaseNotification } from './Base';
const StyledNotification = styled(BaseNotification) `
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'fit-content')};
  padding: 8px;
  gap: 8px;
  border-radius: 8px;
  ${({ $spacer }) => $spacer &&
    css `
      margin-bottom: 24px;
    `};
`;
export const InlineNotification = ({ spacer, uncloseable, fullWidth, ...rest }) => (_jsx(StyledNotification, { ...rest, $spacer: spacer, $fullWidth: fullWidth, closeable: !uncloseable }));
